import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import esES from 'antd/es/locale/es_ES';
import * as serviceWorker from './serviceWorker';
import './index.css';

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <Router>
                <ConfigProvider locale={esES}>
                    <App />
                </ConfigProvider>
            </Router>
        </HashRouter>
    </Provider>
    , document.getElementById('root'));

serviceWorker.unregister();
